import { uniq } from '../../utils/helpers'; // https://uppy.io/docs/uppy/#restrictions
// Do not allow upload html,liquid and svg files because these extensions are blocked due to phishing protections

var permissibleTypes = {
  video: ['video/*'],
  audio: ['audio/*'],
  image: ['image/*', '.png', '.jpg', '.jpeg'],
  other: ['application/pdf', 'audio/mpeg', '.3g2', '.3gp', '.avi', '.csv', '.doc', '.docx', '.epub', '.flv', '.gif', '.key', '.m4a', '.mov', '.mp3', '.mp4', '.mpg', '.mobi', '.odt', '.ogg', '.ogv', '.pdf', '.ppt', '.pptx', '.rtf', '.srt', '.txt', '.wav', '.wma', '.wmv', '.xls', '.xlsx', '.zip', '.gz', '.css', '.scss', '.js', '.ico', '.swf', '.eot', '.ttf', '.woff', '.woff2', '.aac', '.ai', '.als', '.bmp', '.dotx', '.eps', '.flp', '.gdoc', '.gsheet', '.heic', '.jfif', '.m4v', '.mid', '.mkv', '.mpeg', '.numbers', '.odp', '.ods', '.pages', '.psd', '.psfx', '.pub', '.rar', '.rpp', '.tif', '.tiff', '.unity', '.webp', '.xlsb', '.cer', '.p8', '.p12', '.json', '.mobileprovision']
};

var FileTypesConfig = function FileTypesConfig() {
  var _props$extensions;

  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var passedExtensions = ((_props$extensions = props.extensions) === null || _props$extensions === void 0 ? void 0 : _props$extensions.split(',').map(function (s) {
    return s.trim();
  })) || [];
  var permittedExtensions = [];
  var permittedTypes = [];
  passedExtensions.forEach(function (x) {
    Object.keys(permissibleTypes).forEach(function (type) {
      if (permissibleTypes[type].includes(x)) {
        permittedTypes.push(type);
        permittedExtensions.push(x);
      }
    });
  });
  permittedExtensions = uniq(permittedExtensions);

  if (!permittedExtensions.length) {
    permittedExtensions = null;
  }

  return {
    filetypes: uniq(permittedTypes),
    extensions: permittedExtensions // return null or array

  };
};

export default FileTypesConfig;